import { ref, computed } from 'vue'
import { backgrounds } from '@/data/backgrounds.js'

export function useBackground() {
  const currentBackgroundIndex = ref(Math.floor(Math.random() * backgrounds.length))
  const isBackgroundError = ref(false) // 恢复正常，允许背景图片显示
  
  const currentBackground = computed(() => backgrounds[currentBackgroundIndex.value])
  
  const loadRandomBackground = (resetError = true) => {
    let newBgIndex
    do {
      newBgIndex = Math.floor(Math.random() * backgrounds.length)
    } while (newBgIndex === currentBackgroundIndex.value && backgrounds.length > 1)
    
    currentBackgroundIndex.value = newBgIndex
    // 只有明确要求时才重置错误状态
    if (resetError) {
      isBackgroundError.value = false
    }
    return backgrounds[newBgIndex]
  }
  
  const setBackgroundError = (error) => {
    isBackgroundError.value = error
  }
  
  const preloadImage = (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image()
      img.onload = () => {
        setBackgroundError(false)
        resolve(url)
      }
      img.onerror = () => {
        setBackgroundError(true)
        reject(new Error('Failed to load image'))
      }
      img.src = url
    })
  }
  
  // 专门用于换背景图的预加载函数，失败时不设置错误状态
  const preloadImageForRefresh = (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image()
      
      img.onload = () => {
        // 成功时确保背景可见
        if (isBackgroundError.value) {
          setBackgroundError(false)
        }
        resolve(url)
      }
      
      img.onerror = () => {
        // 失败时不修改背景错误状态，让调用者处理
        reject(new Error('Failed to load image'))
      }
      
      img.src = url
    })
  }
  
  const toggleTransparentBackground = () => {
    if (isBackgroundError.value) {
      // 当前是透明背景，切换到图片背景
      isBackgroundError.value = false
    } else {
      // 当前是图片背景，切换到透明背景
      isBackgroundError.value = true
    }
  }
  
  return {
    currentBackground,
    currentBackgroundIndex,
    isBackgroundError,
    loadRandomBackground,
    setBackgroundError,
    preloadImage,
    preloadImageForRefresh,
    toggleTransparentBackground
  }
}